module.exports = __webpack_public_path__ + "img/Day5_final_lazy.5346dc7a.jpg";